import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartsModule } from '@app/shared/components/charts/charts.module';
import { DataItemContentComponent } from '@app/shared/components/data-item/data-item-content.component';
import { DataItemContentInfoComponent } from '@app/shared/components/data-item/data-item-content-info.component';
import { DataItemContentRightComponent } from '@app/shared/components/data-item/data-item-content-right.component';
import { DataItemInfoComponent } from '@app/shared/components/data-item/data-item-info.component';
import { DataItemLayoutComponent } from '@app/shared/components/data-item/data-item-layout.component';
import { DataItemWrapperComponent } from '@app/shared/components/data-item/data-item-wrapper.component';
import { BooleanIconColumnComponent } from '@app/shared/components/display-columns/boolean-icon-column.component';
import { DisplayColumnsComponent } from '@app/shared/components/display-columns/display-columns.component';
import { HeaderWrapperComponent } from '@app/shared/components/header/header-wrapper.component';
import { ItemsPerPageComponent } from '@app/shared/components/items-per-page/items-per-page.component';
import { ModalLayoutModule } from '@app/shared/components/modal-layout/modal-layout.module';
import {
  OperationPointsSearchFormComponent
} from '@app/shared/components/operationpoint_search/operation-points-search-form.component';
import { PaginationComponent } from '@app/shared/components/pagination/pagination.component';
import { PopOverModule } from '@app/shared/components/pop-over/pop-over.module';
import { PopOverContentComponent } from '@app/shared/components/pop-over/pop-over-content.component';
import { PopOverFooterComponent } from '@app/shared/components/pop-over/pop-over-footer.component';
import { SearchComponent } from '@app/shared/components/search/search.component';
import { WizardNavigationComponent } from '@app/shared/components/wizard/wizard-navigation.component';
import { WizardNavigationStepComponent } from '@app/shared/components/wizard/wizard-navigation-step.component';
import { WizardTitleComponent } from '@app/shared/components/wizard/wizard-title.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PcsComponentLibraryModule } from 'pcs-component-library';

@NgModule({
  declarations: [
    WizardNavigationComponent,
    WizardNavigationStepComponent,
    WizardTitleComponent,
    HeaderWrapperComponent,
    DataItemWrapperComponent,
    DataItemLayoutComponent,
    DataItemInfoComponent,
    DataItemContentInfoComponent,
    DataItemContentComponent,
    DataItemContentRightComponent,
    PopOverFooterComponent,
    PopOverContentComponent,
    SearchComponent,
    PaginationComponent,
    ItemsPerPageComponent,
    DisplayColumnsComponent,
    BooleanIconColumnComponent,
    OperationPointsSearchFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    DirectivesModule,
    PopOverModule,
    ModalLayoutModule,
    PcsComponentLibraryModule,
    PipesModule
  ],
  providers: [],
  exports: [
    NgbModule,
    WizardNavigationComponent,
    WizardNavigationStepComponent,
    WizardTitleComponent,
    HeaderWrapperComponent,
    DataItemWrapperComponent,
    DataItemLayoutComponent,
    DataItemInfoComponent,
    DataItemContentInfoComponent,
    DataItemContentComponent,
    DataItemContentRightComponent,
    PopOverFooterComponent,
    PopOverContentComponent,
    PaginationComponent,
    SearchComponent,
    ItemsPerPageComponent,
    DisplayColumnsComponent,
    BooleanIconColumnComponent,
    PopOverModule,
    ModalLayoutModule,
    ChartsModule,
    OperationPointsSearchFormComponent
  ]
})
export class ComponentsModule {
}
